import * as React from 'react';
import "./MatrixVariableLabel.scss";
import {AiOutlineSearch} from 'react-icons/ai';

import { FaChevronDown, FaLongArrowAltDown, FaLongArrowAltRight, FaMinusCircle } from 'react-icons/fa';
import VarsModel from '../../../../../Models/Variables/VarsModel.Model';
class MatrixVariableLabelMenuItem extends React.Component<any> {
  constructor(props) {
    super(props)
    this.state = {showMenu:true}
    this.onClick   = this.onClick.bind(this)


  }
  onClick() {
    this.props.setShowMenu(null, null, true, null)
    this.props.delegate.setVariableForAxis(this.props.item.value, this.props.side, this.props.x, this.props.y);
   }
  render() {
    return <div className="MatrixVariableLabelMenuItem" onClick={this.onClick}>{this.props.item.label}</div>

  }
}


export default  class MatrixVariableLabel extends React.Component<any, any> {

  constructor(props) {
    super(props)
    this.state = {showMenu:true,searchQuery:""}
    this.searchOnChange = this.searchOnChange.bind(this)
    this.openMenu   = this.openMenu.bind(this)
    this.closeMenu   = this.closeMenu.bind(this)


  }
  searchOnChange(e) { this.setState({searchQuery:e.target.value}); }

  openMenu(e) {
    e.stopPropagation();
    this.setState({searchQuery:""})
    if (!(this.props.showMenu && this.props.showMenu.x === this.props.x && this.props.showMenu.y === this.props.y && this.props.showMenu.side === this.props.side)) {
      this.props.setShowMenu(this.props.x, this.props.y, false, this.props.side)
    }
  }
  closeMenu(e) {
    e.stopPropagation();

    this.setState({searchQuery:""})
    this.props.setShowMenu(null, null, true, null)
  }

  render() {
    let className = "MatrixVariableLabel"

    let  directionArrow;
    if(this.props.side === "right") {
      className += " rightLabel"
      directionArrow = <FaLongArrowAltRight />;
    } else {
      className += " bottomLabel"
      directionArrow = <FaLongArrowAltDown />;

    }

    let menu;
    if (this.props.showMenu && this.props.showMenu.x === this.props.x && this.props.showMenu.y === this.props.y && this.props.showMenu.side === this.props.side) {
      className += " showMenu";

      var vars = VarsModel.variableOptions(true,true, undefined,  true)
      if (this.state.searchQuery.length) { vars = vars.filter((item:any) => item.label.toLowerCase().includes(this.state.searchQuery.toLowerCase())); }

      const varButtons = vars.map((item:any) => {
        return <MatrixVariableLabelMenuItem
                item={item}
                delegate={this.props.delegate}
                key={item.id}
                selectedVariable={this.props.variable}
                side={this.props.side}
                x={this.props.x}
                y={this.props.y}
                setShowMenu={this.props.setShowMenu}/>
      })

      menu = <div className="menu">
            <div className="searchBoxWrapper">
            <div className="searchBox">
              <AiOutlineSearch />
              <input onChange={this.searchOnChange} value={this.state.searchQuery} />
            </div>
            <div className="closeButton" onClick={this.closeMenu}><FaMinusCircle /></div>

            </div>
            <div className="content">
              {varButtons}
            </div>

            </div>
    } else {
      menu = <div className="menu"></div>
    }
    var variableName = VarsModel.nameForVariable(this.props.variable)
    if (!variableName) {
      className += " missingVariable"
      variableName = "MISSING VARIABLE"
    }
    if (!this.props.canEdit) {
      return  <div className={className}>
      <div className="label">
        <span>
    
         </span>
        {variableName}
      </div>
    </div>
    }
    return  <div className={className}>
              <div className="label" onClick={this.openMenu}>
                <span>
                  <FaChevronDown />
            
                 </span>
                {variableName}
                {directionArrow}
                {menu}
              </div>
            </div>
  }
}
